import * as runtime from '@/api/runtime'

import {
  BatchStatisticsRegUsrRequest,
  BatchStatisticsRegUsrRequestToJSON
} from '@/api/models/batch/BatchStatisticsRegUsrRequest'

import {
  BatchStatisticsGetSelectItemRequest,
  BatchStatisticsGetSelectItemRequestToJSON,
  BatchStatisticsGetSelectItemResult,
  BatchStatisticsGetSelectItemResultFromJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchStatisticsGetPredefinedSettingRequest,
  BatchStatisticsGetPredefinedSettingRequestToJSON
} from '@/api/models/batch/BatchStatisticsGetPredefinedSettingRequest'
import {
  BatchStatisticsRegUsrSelectItemResult,
  BatchStatisticsRegUsrSelectItemResultFromJSON
} from '@/api/models/batch/BatchStatisticsRegUsrSelectItemResult'

export class BatchStatisticsRegUsrApi extends runtime.BaseAPI {
  /**
   * 検索状態登録
   * @param request
   */
  async registPattern(
    request: BatchStatisticsRegUsrRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestPost(
      `/batch/statistics/regist_regusr_pattern`,
      BatchStatisticsRegUsrRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 登録済み出力条件取得
   * @param request
   */
  async getPredefinedSetting(
    request: BatchStatisticsGetPredefinedSettingRequest
  ): Promise<BatchStatisticsRegUsrSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/list_item`,
      BatchStatisticsGetPredefinedSettingRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsRegUsrSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * セレクト項目取得
   * @param request
   */
  async getSelectItem(
    request: BatchStatisticsGetSelectItemRequest
  ): Promise<BatchStatisticsGetSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_select_item`,
      BatchStatisticsGetSelectItemRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsGetSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchStatisticsRegUsrSelectItemResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchStatisticsRegUsrSelectItemResultFromJSON(jsonValue)
    ).value()
  }

  /**
   * 帳票作成
   * @param request
   */
  async createRegUsr(request: BatchStatisticsRegUsrRequest): Promise<number> {
    const response = await this.requestPost(
      `/batch/statistics/regusr`,
      BatchStatisticsRegUsrRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
